import { Component, OnInit } from '@angular/core';
import { DataService } from '@adscore/adscore-frontend-common';
import { AdscoreMinModule } from 'adscore/adscore-min.module';
import { PhoneConfirmationService } from 'adscore/services/phone-confirmation/phone-confirmation.service';
import { CtaComponent } from 'adscore/components/cta/cta.component';
import { PasswordResetComponent } from 'adscore/components/password-reset/password-reset.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [AdscoreMinModule, CtaComponent, PasswordResetComponent, CommonModule],
  providers: [PhoneConfirmationService]
})
export class HomeComponent implements OnInit {
  showPhoneConfirmation = false;
  showPasswordReset = false;
  displayLoader = false;

  constructor(
    private dataService: DataService,
    private phoneConfirmationService: PhoneConfirmationService,
    private router: Router
  ) {
    if (this.dataService.pop('show-phone-confirmation-modal')) {
      this.phoneConfirmationService.showPhoneConfirmationModal();
    }
    this.showPasswordReset = this.dataService.pop('show-password-reset-modal');
  }

  ngOnInit(): void {
    if (this.router.url.includes('email-verification') || this.router.url.includes('password-reset')) {
      this.displayLoader = true;
    }
  }
}
